import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { FETCH_ASSETS_URL } from 'appenv';
import FileArrow from 'components/icons/FileArrow';

const whiteShelfImg = `${FETCH_ASSETS_URL}/assets/booths/white-shelf.png`;

const StyledImg = styled.img`
  max-width: 100%;
  max-height: 100%;
`;

const ArrowContainer = styled.div`
  position: absolute;
  left: 55px;
  top: 18px;
`;

const WhiteShelf = ({ hasAttachment }) => {
  const { themeColor } = useSelector((state) => state.eventConfigs);

  return (
    <>
      <StyledImg src={whiteShelfImg} />
      {hasAttachment && (
        <ArrowContainer>
          <FileArrow color={themeColor} width={40} height={40} />
        </ArrowContainer>
      )}
    </>
  );
};

WhiteShelf.propTypes = {
  hasAttachment: PropTypes.bool.isRequired,
};

export default WhiteShelf;
